import { Suspense, lazy, useState } from "react";
import LoadingFullPage from "../components/common/Loading/LoadingFullPage";
import { useLocation, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { useSelector } from "react-redux";
import LeftSideBar from "../components/LeftSideBar/index";
import TopBar from "../components/TopBar";

import { SCOPES } from "../contants";

const ManageBranches = lazy(() => import("../pages/Branches/ManageBranches"));
const ManageItemCategories = lazy(
  () => import("../pages/ItemCategories/ManageItemCategories"),
);
const ManageItemAvailability = lazy(() => import("../pages/ItemAvailability"));
const Vendor = lazy(() => import("../pages/vendor"));
const ManageItems = lazy(() => import("../pages/Items/ManageItems"));
const ManageTables = lazy(() => import("../pages/Tables/ManageTables"));
const ManageTableTypes = lazy(() => import("../pages/TableTypes/index"));
const ManageBranchExpense = lazy(
  () => import("../pages/Expense/BranchExpense"),
);
const AddRestaurant = lazy(
  () => import("../pages/Restaurant/ManageRestaurant"),
);
const ManageSubScriptions = lazy(
  () => import("../pages/Subscriptions/ManageSubscriptions"),
);
const ManageThemes = lazy(() => import("../pages/Themes/ManageThemes"));
const ManageUsers = lazy(() => import("../pages/Users/ManageUsers"));
const AddModal = lazy(() => import("../pages/Users/ManageUsers/AddModal"));
const OrderDashboard = lazy(() => import("../pages/OrderDashboard"));
const DashBoard = lazy(() => import("../pages/DashBoard"));
const Reports = lazy(() => import("../pages/Reports"));
const ManageExpenseTypes = lazy(() => import("../pages/ExpenseTypes"));
const RestaurantExpenseTypes = lazy(
  () => import("../pages/ExpenseTypes/RestaurantExpenseTypes"),
);
const BookingSpaces = lazy(() => import("../pages/Bookings"));
const OrderHistory = lazy(() => import("../pages/OrderHistory"));

const Settings = lazy(() => import("../pages/Settings"));
const ManageRawMaterials = lazy(() => import("../pages/RawMaterials"));
const KitchenDisplay = lazy(() => import("../pages/KitchenDisplay"));
const OrderSummaryData = lazy(() => import("../pages/OrderSummaryData"));

const DashBoardRoutes = () => {
  const role = useSelector((state) => state.user.role);
  const { pathname } = useLocation();
  const [sideMenuOpen, setSideMenuOpen] = useState(false);
  const isBranchUser = role === "branchuser";
  const isRestaurantAdmin = role === "restaurantadmin";
  const isKitchenUser = role === "kitchenuser";
  const superadmin = "superadmin";
  const restaurantadmin = "restaurantadmin";
  const branchadmin = "branchadmin";
  const branchuser = "branchuser";
  const kitchenuser = "kitchenuser";
  const isFullPageDashboard =
    pathname === "/order" ||
    pathname === "/kitchen" ||
    (pathname === "/" && (isBranchUser || isKitchenUser));

  return (
    <main
      className="data-container"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      {!isKitchenUser && (
        <LeftSideBar
          sideMenuOpen={sideMenuOpen}
          setSideMenuOpen={setSideMenuOpen}
        />
      )}

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
          minHeight: 0,
          minWidth: 0,
        }}
      >
        <div style={{ flexShrink: 0 }}>
          <TopBar
            hide={isBranchUser && pathname === "/"}
            sideMenuOpen={sideMenuOpen}
            setSideMenuOpen={setSideMenuOpen}
          />
        </div>
        <div
          className={`dashboard-container ${isFullPageDashboard ? "p-0" : ""}`}
          style={{ flex: 1, width: "100%", overflow: "auto", minHeight: 0 }}
        >
          <Suspense fallback={<LoadingFullPage />}>
            <Routes>
              {isBranchUser && <Route path="/" element={<OrderDashboard />} />}
              {isKitchenUser && (
                <Route
                  path="/"
                  element={
                    <ProtectedRoute
                      roles={[kitchenuser]}
                      component={KitchenDisplay}
                    />
                  }
                />
              )}

              <Route
                path="/order"
                element={
                  <ProtectedRoute
                    roles={[branchadmin, branchuser]}
                    component={OrderDashboard}
                  />
                }
              />
              <Route
                path="/kitchen"
                element={
                  <ProtectedRoute
                    roles={[kitchenuser]}
                    component={KitchenDisplay}
                    scopes={[SCOPES.KITCHEN_DISPLAY_SYSTEM]}
                  />
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute
                    roles={[superadmin, branchadmin, restaurantadmin]}
                    component={DashBoard}
                  />
                }
              />
              <Route
                path="/managerestaurant"
                element={
                  <ProtectedRoute
                    roles={[superadmin]}
                    component={AddRestaurant}
                  />
                }
              />

              <Route
                path="/bookings"
                element={
                  <ProtectedRoute
                    roles={[branchadmin, restaurantadmin]}
                    component={BookingSpaces}
                    scopes={[SCOPES.BOOKING_SYSTEM]}
                  />
                }
              />

              <Route
                path="/managebranches"
                element={
                  <ProtectedRoute
                    roles={[superadmin, restaurantadmin]}
                    component={ManageBranches}
                  />
                }
              />

              <Route
                path="/manageusers"
                element={
                  <ProtectedRoute
                    roles={[superadmin, restaurantadmin, branchadmin]}
                    component={ManageUsers}
                  />
                }
              />

              <Route
                path="/adduser"
                element={
                  <ProtectedRoute
                    roles={[superadmin, restaurantadmin]}
                    component={AddModal}
                  />
                }
              />

              <Route
                path="/managethemes"
                element={
                  <ProtectedRoute
                    roles={[superadmin]}
                    component={ManageThemes}
                  />
                }
              />

              <Route
                path="/managesubscriptions"
                element={
                  <ProtectedRoute
                    roles={[superadmin]}
                    component={ManageSubScriptions}
                  />
                }
              />

              <Route
                path="/managecategories"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, superadmin, branchadmin]}
                    component={ManageItemCategories}
                  />
                }
              />

              <Route
                path="/manageitems"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin]}
                    component={ManageItems}
                  />
                }
              />

              <Route
                path="/manageitemavailability"
                element={
                  <ProtectedRoute
                    roles={[branchadmin]}
                    component={ManageItemAvailability}
                  />
                }
              />

              <Route
                path="/vendor"
                element={
                  <ProtectedRoute roles={[branchadmin]} component={Vendor} />
                }
              />

              <Route
                path="/managetables"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin]}
                    component={ManageTables}
                  />
                }
              />
              <Route
                path="/managerawmaterials"
                element={
                  <ProtectedRoute
                    roles={[branchadmin]}
                    component={ManageRawMaterials}
                  />
                }
              />

              <Route
                path="/managetabletypes"
                element={
                  <ProtectedRoute
                    roles={[superadmin, restaurantadmin]}
                    component={ManageTableTypes}
                  />
                }
              />
              <Route
                path="/manageexpensetypes"
                element={
                  <ProtectedRoute
                    roles={[superadmin]}
                    component={ManageExpenseTypes}
                  />
                }
              />

              <Route
                path="/manageexpense"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin, branchuser]}
                    component={
                      isRestaurantAdmin
                        ? RestaurantExpenseTypes
                        : ManageBranchExpense
                    }
                  />
                }
              />

              <Route
                path="/orderhistory"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin]}
                    component={OrderHistory}
                  />
                }
              />

              <Route
                path="/ordersummary"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin]}
                    component={OrderSummaryData}
                  />
                }
              />

              <Route
                path="/settings"
                element={
                  <ProtectedRoute
                    roles={[branchadmin, branchuser]}
                    component={Settings}
                  />
                }
              />
              <Route
                path="/reports/:reportType"
                element={
                  <ProtectedRoute
                    roles={[restaurantadmin, branchadmin]}
                    component={Reports}
                  />
                }
              />
            </Routes>
          </Suspense>
        </div>
      </div>
    </main>
  );
};

export default DashBoardRoutes;
